import base from './base.repository';

export default {
    ...base,
    getPaged(page = 1, filters) {
        const params = { ...filters, page };
        this.get(`quotations${this.querify(params)}`);
        return this;
    },
    getQuotation(id) {
        this.get(`quotations/${id}`);
        return this;
    },
    saveQuotation(payload) {
        this.post('quotations', payload);
        return this;
    },
    updateQuotation(payload, id) {
        this.put(`quotations/${id}`, payload);
        return this;
    },
    deleteQuotation(id) {
        this.delete(`quotations/${id}`);
        return this;
    },
    restoreQuotation(id) {
        this.post(`quotations/${id}/restore`);
        return this;
    },
    getQuotationLogs(id) {
        this.get(`quotations/${id}/logs`);
        return this;
    },
    getClients() {
        this.get('quotations/clients');
        return this;
    },
    getItemsByCategory(categorySlug) {
        this.get(`quotations/items-by-category/${categorySlug}`);
        return this;
    },
    getQuotationSettings() {
        this.get('quotations/settings');
        return this;
    }
};

